var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tabs"},_vm._l((_vm.tabs),function(tab,index){return _c('div',{key:index,staticClass:"tabs__item",class:{ selected: tab.value === _vm.selectedTab.value },on:{"click":function($event){return _vm.onTabSelect(tab)}}},[_vm._v(_vm._s(tab.label))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }